"use strict";define("plugin/emoji-extended/detection/plain",function(){return{allowCompletion:function(){return!0}}});